import { FC, useContext, useMemo } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import {
  AuthenticationContext,
  HeroConversationMessage,
  ConversationMessageType,
} from '@vs-online-only-app/state';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';
import { Check } from '@mui/icons-material';

type Props = {
  message: HeroConversationMessage;
};

const EndedChatMessage: FC<Props> = ({ message }) => {
  const { user: authenticatedUser } = useContext(AuthenticationContext);
  const conversation = useSelectedHeroConversation();
  const isAutoEnded =
    message.attributes.type === ConversationMessageType.AutoEndedChat;

  const messageBody = useMemo(() => {
    if (isAutoEnded) {
      return 'Chat ended automatically.';
    }
    if (authenticatedUser?.username === message.author) {
      return 'You ended this chat.';
    }
    const authorFirstName = conversation?.participants.find(
      (participant) => participant.username === message.author
    )?.firstName;
    return `${authorFirstName} ended this chat.`;
  }, [isAutoEnded, authenticatedUser, conversation, message.author]);

  return (
    <>
      <Box minHeight={(theme) => theme.spacing(2)} />
      <Stack alignItems="center">
        <Chip
          label={
            <Stack direction="row" gap={1}>
              <Check fontSize="small" />
              <Typography variant="body2" color="textSecondary">
                {messageBody}
              </Typography>
            </Stack>
          }
        />
      </Stack>
      <Box minHeight={(theme) => theme.spacing(2)} />
    </>
  );
};

export default EndedChatMessage;
